var _excluded = ["align", "className", "children", "color", "inverse", "marginBottom", "marginLeft", "marginRight", "marginTop", "size", "weight", "variation"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Text from "../Text";
import { getResponsiveValue } from "../../utils";
var Paragraph = function Paragraph(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'inherit' : _ref$align,
    className = _ref.className,
    children = _ref.children,
    color = _ref.color,
    inverse = _ref.inverse,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '05' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    size = _ref.size,
    weight = _ref.weight,
    variation = _ref.variation,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Text, _extends({
    align: getResponsiveValue(align),
    as: "p",
    className: className,
    color: color,
    marginBottom: getResponsiveValue(marginBottom),
    marginLeft: getResponsiveValue(marginLeft),
    marginRight: getResponsiveValue(marginRight),
    marginTop: getResponsiveValue(marginTop),
    inverse: inverse,
    size: size,
    variation: variation,
    weight: weight
  }, rest), children);
};
Paragraph.displayName = 'Paragraph';
export default Paragraph;